<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Delete SSN</h4>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-sm-9 col-md-8 col-lg-7 mvd_form-group">
            <customer-search-bar [label]="'Customer'" [autoHideSearch]="true" [customerNumberId]="customerNumberId"
                                 [hideUntilLoaded]="!!customerNumberId" [includeDeceased]="false"
                                 (onItemSelected)="customerSelected($event)">
            </customer-search-bar>
        </div>
        <ng-container *ngIf="showSSNTable">
            <div class="col-4 col-sm-2 mvd_form-group">
                <label>SSN</label>
                <div class="mvd_form-control">{{this.customerSSN}}</div>
            </div>
            <div class="col-1 col-md-1 mvd_form-group">
                <label>&nbsp;</label>
                <a class="icon--delete" title="Delete SSN" href="javascript:void(0)" (click)="deleteIdentification()"></a>
            </div>
        </ng-container>
    </div>

    <div class="mvd_alert--label" *ngIf="showMessage">
        Cannot delete the SSN
    </div>
    <div class="mvd_alert--satisfied" *ngIf="showSuccessMessage">
        Successfully deleted SSN
    </div>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--primary" (click)="cancel()">Cancel</button>
    </div>
</div>